import { Material } from "../../order/resources/material";
import { Order } from "../../order/resources/order";
import { Paint } from "../../order/resources/paint";
import { PurchasedItem } from "../../order/resources/purchased-item";
import { Station } from "../../order/resources/station";
import { WorkOrder } from "../../planning/resources/work-order";
import { MaterialBid } from "../../purchasing/resources/materialBid";
import { OutsideProcessDescription } from "../../purchasing/resources/outsideProcessDescription";
import { PurchaseOrder } from "../../purchasing/resources/purchaseOrder";
import { PurchasingSheetItem } from "./purchasingSheet";

export enum ProcurementQueueTicketType {
    ACQUISITION = 0,
    QUOTING = 1,
}

export class ProcurementQueueTicket {
        procurementQueueTicketId: string 
        ticketType: ProcurementQueueTicketType 

        quantity: number
        dueDate?: Date 

        materialId?: string 
        stationId?: string 
        outsideProcessDescriptionId?: string 
        purchasedItemId?: string 
        paintId?: string 

        workOrderId?: string 
        purchaseOrderId?: string 
        estimateId?: string 
        validity?: number;

        outsideProcessDescription: OutsideProcessDescription 
        station?: Station 
        material?: Material 
        purchasedItem?: PurchasedItem 
        paint?: Paint 

        workOrder?: WorkOrder
        purchaseOrder?: PurchaseOrder 
        estimate?: Order 

        purchasingSheetItem?: PurchasingSheetItem;
}
